export default "__VITE_ASSET__1802fbee__"